//CharacterStrip.tsx — character mode's dock: tap a character to become it, tap another to swap

import type { Character } from '../../shared/character'
import { CheckIcon } from './icons'
import { ScrollStrip } from './ScrollStrip'

interface Props {
	characters: readonly Character[]
	selectedId: string | null
	disabled: boolean
	onSelect: (character: Character) => void
}

//Same tile markup and classes as GarmentStrip, so both docks look and scroll alike.
export function CharacterStrip({ characters, selectedId, disabled, onSelect }: Props) {
	return (
		<ScrollStrip label="Characters" itemCount={characters.length}>
			{characters.map((character) => {
				const selected = character.id === selectedId
				return (
					<button
						key={character.id}
						type="button"
						role="option"
						aria-selected={selected}
						className={`tile ${selected ? 'is-selected' : ''}`}
						disabled={disabled}
						onClick={() => onSelect(character)}
						title={character.name}
					>
						<span className="tile-image">
							{character.imageURL && (
								<img src={character.imageURL} alt="" loading="lazy" decoding="async" />
							)}
							<span className="tile-badge" aria-hidden="true">
								<CheckIcon />
							</span>
						</span>
						<span className="tile-label">
							<span className="tile-title">{character.name}</span>
						</span>
					</button>
				)
			})}
		</ScrollStrip>
	)
}
